/**
 * Nucery cart drawer — /cart.js + /cart/change.js, syncs with Impulse cart:updated.
 */
(function () {
  'use strict';

  var TRASH_ICON =
    '<span class="nucery-cart-drawer__item-remove-ic" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M3 6h18"></path><path d="M8 6V4a1 1 0 011-1h6a1 1 0 011 1v2"></path>' +
    '<path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6"></path><path d="M10 11v6M14 11v6"></path></svg></span>';

  var root;
  var config = {};
  var open = false;
  var prevTierState = null;
  function removeIconInner() {
    if (config.removeIconStyle === 'x') {
      return '<span class="nucery-cart-drawer__item-remove-x" aria-hidden="true">×</span>';
    }
    return TRASH_ICON;
  }

  function qs(sel, ctx) {
    return (ctx || root).querySelector(sel);
  }

  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || root).querySelectorAll(sel));
  }

  function ensureRoot() {
    root = document.getElementById('NuceryCartDrawer');
    return root;
  }

  /** Re-parse section JSON (theme editor swaps section HTML; config must stay with this drawer). */
  function readConfig() {
    var drawer = ensureRoot();
    var cfgEl = drawer && drawer.querySelector('script[type="application/json"][data-nucery-cart-config]');
    if (!cfgEl) cfgEl = document.getElementById('NuceryCartDrawerConfig');
    try {
      config = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    } catch (err) {
      config = {};
    }
    if (config.trackStartOverride === '') config.trackStartOverride = null;
    config.strings = config.strings || {};
    config.shopCurrency = config.shopCurrency || config.currency || 'USD';
    applyThresholdsFromConfig();
    if (root) {
      var dsProgress = root.getAttribute('data-show-progress');
      if (dsProgress === 'false') config.showProgress = false;
      else if (dsProgress === 'true') config.showProgress = true;
    }
    if (config.showProgress !== false && config.showProgress !== 'false') {
      config.showProgress = true;
    } else {
      config.showProgress = false;
    }
  }

  function isProgressEnabled() {
    if (config.showProgress === false || config.showProgress === 'false') return false;
    if (root && root.getAttribute('data-show-progress') === 'false') return false;
    return config.showProgress !== false;
  }

  function clearProgressState() {
    if (!root) return;
    root.classList.remove('ncd--ship-reached', 'ncd--gift-reached', 'ncd--just-ship', 'ncd--just-gift');
    prevTierState = null;
  }

  /** Cart total in smallest presentment unit (same as /cart.js line prices). */
  function cartTotalCents(cart) {
    if (!cart) return 0;
    var tp = Number(cart.total_price);
    if (isFinite(tp) && tp > 0) return tp;
    if (cart.items && cart.items.length) {
      var sum = 0;
      for (var i = 0; i < cart.items.length; i++) {
        sum += Number(cart.items[i].final_line_price) || 0;
      }
      if (sum > 0) return sum;
    }
    var sub = Number(cart.items_subtotal_price);
    if (isFinite(sub) && sub > 0) return sub;
    var ot = Number(cart.original_total_price);
    if (isFinite(ot) && ot > 0) return ot;
    return isFinite(tp) ? tp : 0;
  }

  function formatMoney(cents) {
    cents = Number(cents) || 0;
    var cur = (config.currency || config.shopCurrency || 'USD').toString();
    var shopCur = (config.shopCurrency || '').toString();
    var fmt = config.moneyFormat || (window.theme && window.theme.settings && window.theme.settings.moneyFormat);
    var shopifyOk = window.Shopify && typeof Shopify.formatMoney === 'function' && fmt;
    if (shopifyOk && (!shopCur || cur === shopCur)) {
      return Shopify.formatMoney(cents, fmt);
    }
    var n = cents / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(n);
    } catch (e) {
      if (shopifyOk) return Shopify.formatMoney(cents, fmt);
      return n.toFixed(2) + ' ' + cur;
    }
  }

  /** Shopify.formatMoney returns HTML; use this inside textContent-only nodes. */
  function formatMoneyPlain(cents) {
    var html = String(formatMoney(cents));
    var d = document.createElement('div');
    d.innerHTML = html;
    return (d.textContent || d.innerText || '').trim();
  }

  function setBodyScroll(lock) {
    document.documentElement.classList.toggle('nucery-cart-drawer--open', lock);
    document.body.classList.toggle('nucery-cart-drawer--open', lock);
  }

  function updateHeaderBadges(count) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nucery-cart-count]'), function (el) {
      el.textContent = String(count);
      el.hidden = count < 1;
      el.setAttribute('aria-hidden', count < 1 ? 'true' : 'false');
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function findLineItemRow(key) {
    if (!root || !key) return null;
    return root.querySelector('.nucery-cart-drawer__item[data-line-key="' + CSS.escape(String(key)) + '"]');
  }

  function changeLine(key, quantity) {
    if (!ensureRoot()) return Promise.resolve();
    var row = findLineItemRow(key);
    if (row) row.classList.add('nucery-cart-drawer__item--busy');
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (cart && Array.isArray(cart.items)) applyCart(cart, { animate: false });
        return cart;
      })
      .finally(function () {
        if (row) row.classList.remove('nucery-cart-drawer__item--busy');
      });
  }

  function lineItemImageUrl(item) {
    var imgUrl = item.image || (item.featured_image && item.featured_image.url) || '';
    if (imgUrl && imgUrl.indexOf('width=') === -1) {
      imgUrl += (imgUrl.indexOf('?') === -1 ? '?' : '&') + 'width=200';
    }
    return imgUrl;
  }

  function createItemElement(item, index, animate) {
    var article = document.createElement('article');
    article.className = 'nucery-cart-drawer__item' + (animate ? ' ncd-item--animate' : '');
    article.setAttribute('data-line-key', item.key);
    if (animate) article.style.setProperty('--ncd-item-delay', index * 70 + 'ms');

    var imgUrl = lineItemImageUrl(item);
    article.innerHTML =
        '<a class="nucery-cart-drawer__item-media" href="' +
        escapeAttr(item.url) +
        '">' +
        (imgUrl
          ? '<img src="' +
            escapeAttr(imgUrl) +
            '" width="88" height="88" loading="lazy" alt="' +
            escapeAttr(item.product_title) +
            '">'
          : '<span class="nucery-cart-drawer__item-ph"></span>') +
        '</a>' +
        '<div class="nucery-cart-drawer__item-body">' +
        '<div class="nucery-cart-drawer__item-top">' +
        '<a class="nucery-cart-drawer__item-title" href="' +
        escapeAttr(item.url) +
        '">' +
        escapeHtml(item.product_title) +
        '</a>' +
        '<button type="button" class="nucery-cart-drawer__item-remove" data-remove-line="' +
        escapeAttr(item.key) +
        '" aria-label="' +
        escapeAttr(config.strings.remove || 'Remove') +
        '" title="' +
        escapeAttr(config.strings.remove || 'Remove') +
        '">' +
        removeIconInner() +
        '</button></div>' +
        '<div class="nucery-cart-drawer__item-bottom">' +
        '<div class="nucery-cart-drawer__qty" data-line-key="' +
        escapeAttr(item.key) +
        '">' +
        '<button type="button" class="nucery-cart-drawer__qty-btn" data-qty-delta="-1" aria-label="Decrease">−</button>' +
        '<span class="nucery-cart-drawer__qty-val">' +
        item.quantity +
        '</span>' +
        '<button type="button" class="nucery-cart-drawer__qty-btn" data-qty-delta="1" aria-label="Increase">+</button></div>' +
        '<span class="nucery-cart-drawer__item-price">' +
        formatMoney(item.final_line_price) +
        '</span></div></div>';

    return article;
  }

  function updateItemElement(el, item) {
    var qtyVal = el.querySelector('.nucery-cart-drawer__qty-val');
    if (qtyVal) qtyVal.textContent = String(item.quantity);
    var price = el.querySelector('.nucery-cart-drawer__item-price');
    if (price) price.innerHTML = formatMoney(item.final_line_price);
  }

  function renderItems(cart, options) {
    options = options || {};
    var animate = !!options.animate;
    var host = qs('[data-nucery-cart-items]');
    if (!host) return;

    if (!cart.items || !cart.items.length) {
      host.innerHTML = '';
      return;
    }

    var existing = {};
    host.querySelectorAll('.nucery-cart-drawer__item[data-line-key]').forEach(function (el) {
      existing[el.getAttribute('data-line-key')] = el;
    });

    cart.items.forEach(function (item, i) {
      var key = item.key;
      var el = existing[key];
      if (el) {
        updateItemElement(el, item);
        delete existing[key];
        host.appendChild(el);
      } else {
        host.appendChild(createItemElement(item, i, animate));
      }
    });

    Object.keys(existing).forEach(function (k) {
      if (existing[k].parentNode) existing[k].remove();
    });
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function escapeAttr(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function parseAmountToCents(raw) {
    if (raw == null) return null;
    var s = String(raw).trim().replace(/\s/g, '');
    if (s === '') return null;
    s = s.replace(',', '.');
    s = s.replace(/[^\d.-]/g, '');
    var n = parseFloat(s);
    if (!isFinite(n) || n < 0) return null;
    return Math.round(n * 100);
  }

  /**
   * Theme thresholds are entered in the store’s primary currency (minor units).
   * Cart /cart.js totals use the customer’s presentment currency when Markets is on.
   * Shopify injects window.Shopify.currency.rate (shop → active).
   */
  function convertShopMinorToCartMinor(shopMinor) {
    var n = Number(shopMinor);
    if (!isFinite(n)) return 0;
    var shop = (config.shopCurrency || '').toString().toUpperCase();
    var cartCur = (config.currency || '').toString().toUpperCase();
    if (!shop || !cartCur || shop === cartCur) return Math.round(n);
    var sc = window.Shopify && window.Shopify.currency;
    var rate = sc && sc.rate != null ? Number(sc.rate) : NaN;
    if (!isFinite(rate) || rate <= 0) return Math.round(n);
    return Math.round(n * rate);
  }

  function applyThresholdsFromConfig() {
    var s1 = parseAmountToCents(config.shippingAmountRaw);
    var s2 = parseAmountToCents(config.giftAmountRaw);
    var fb1 = Number(config.shippingThresholdCentsFallback);
    var fb2 = Number(config.giftThresholdCentsFallback);
    if (!isFinite(fb1)) fb1 = 3500;
    if (!isFinite(fb2)) fb2 = 7000;
    var base1 = s1 != null ? s1 : fb1;
    var base2 = s2 != null ? s2 : fb2;
    config.shippingThresholdCents = convertShopMinorToCartMinor(base1);
    config.giftThresholdCents = convertShopMinorToCartMinor(base2);
    if (config.giftThresholdCents <= config.shippingThresholdCents) {
      config.giftThresholdCents = config.shippingThresholdCents + 1;
    }
  }

  /** Free shipping milestone is fixed at 50% of the bar; fill maps [0,m1)→[0,50%), [m1,m2)→[50%,100%). */
  var SHIP_VISUAL_PCT = 50;

  function progressState(totalCents) {
    var m1 = Number(config.shippingThresholdCents);
    if (!isFinite(m1)) m1 = 3500;
    m1 = Math.max(0, m1);
    var m2 = Number(config.giftThresholdCents);
    if (!isFinite(m2)) m2 = 7000;
    m2 = Math.max(0, m2);
    if (m2 <= m1) m2 = m1 + 1;
    var t = totalCents || 0;
    var remainingShip = Math.max(0, m1 - t);
    var remainingGift = Math.max(0, m2 - t);
    var shipDone = m1 === 0 ? true : t >= m1;
    var giftDone = t >= m2;
    var fillPct;
    if (t >= m2) {
      fillPct = 100;
    } else if (m1 <= 0) {
      fillPct = (t / m2) * 100;
    } else if (t < m1) {
      fillPct = (t / m1) * SHIP_VISUAL_PCT;
    } else {
      var seg = (t - m1) / (m2 - m1);
      fillPct = SHIP_VISUAL_PCT + seg * (100 - SHIP_VISUAL_PCT);
    }
    fillPct = Math.min(100, Math.max(0, fillPct));
    return {
      m1: m1,
      m2: m2,
      t: t,
      remainingShip: remainingShip,
      remainingGift: remainingGift,
      shipDone: shipDone,
      giftDone: giftDone,
      fillPct: fillPct,
      shipDotPct: SHIP_VISUAL_PCT,
    };
  }

  function renderProgress(cart) {
    if (!isProgressEnabled()) {
      clearProgressState();
      return;
    }
    var wrap = qs('[data-nucery-cart-progress]');
    if (!wrap) return;
    var total = cartTotalCents(cart);
    var st = progressState(total);
    var msgEl = qs('[data-nucery-progress-msg]');
    var barFill = qs('[data-nucery-progress-fill]');

    if (msgEl) {
      if (st.giftDone) {
        msgEl.textContent = config.strings.progressAllMet || '';
      } else if (st.shipDone) {
        var tplGift = config.strings.progressGiftRemaining || '';
        msgEl.textContent = tplGift.replace(/__AMOUNT__/g, formatMoneyPlain(st.remainingGift));
      } else {
        var tpl = config.strings.progressShippingRemaining || '';
        msgEl.textContent = tpl.replace(/__AMOUNT__/g, formatMoneyPlain(st.remainingShip));
      }
    }
    if (barFill) barFill.style.width = st.fillPct + '%';

    if (root) {
      var prev = prevTierState;
      root.classList.toggle('ncd--ship-reached', st.shipDone);
      root.classList.toggle('ncd--gift-reached', st.giftDone);
      if (prev && !prev.shipDone && st.shipDone) {
        root.classList.add('ncd--just-ship');
        clearTimeout(root._ncdShipPopT);
        root._ncdShipPopT = setTimeout(function () {
          root.classList.remove('ncd--just-ship');
        }, 700);
      }
      if (prev && !prev.giftDone && st.giftDone) {
        root.classList.add('ncd--just-gift');
        clearTimeout(root._ncdGiftPopT);
        root._ncdGiftPopT = setTimeout(function () {
          root.classList.remove('ncd--just-gift');
        }, 700);
      }
      prevTierState = { shipDone: st.shipDone, giftDone: st.giftDone };
    }

    var startEl = qs('[data-nucery-track-start]');
    if (startEl) {
      var ov = config.trackStartOverride && String(config.trackStartOverride).trim();
      if (ov) startEl.textContent = ov;
      else startEl.innerHTML = formatMoney(0);
    }

    var m1Amt = qs('[data-nucery-milestone-ship-amt]');
    var m2Amt = qs('[data-nucery-milestone-gift-amt]');
    if (m1Amt) m1Amt.innerHTML = formatMoney(st.m1);
    if (m2Amt) m2Amt.innerHTML = formatMoney(st.m2);
  }

  function renderTotals(cart) {
    var sub = qs('[data-nucery-subtotal]');
    var chk = qs('[data-nucery-checkout-price]');
    var titleCount = qs('[data-nucery-cart-title-count]');
    var total = cartTotalCents(cart);
    var count = cart.item_count || 0;
    if (sub) sub.innerHTML = formatMoney(total);
    if (chk) chk.innerHTML = formatMoney(total);
    if (titleCount) titleCount.textContent = String(count);
    updateHeaderBadges(count);
  }

  function toggleEmpty(cart) {
    var empty = !cart.items || !cart.items.length;
    var emptyEl = qs('[data-nucery-cart-empty]');
    var filledEl = qs('[data-nucery-cart-filled]');
    if (emptyEl) emptyEl.hidden = !empty;
    if (filledEl) filledEl.hidden = empty;
    var footLines = qs('[data-nucery-cart-footer-lines]');
    var payRow = qs('[data-nucery-payment-row]');
    if (footLines) footLines.hidden = empty;
    if (payRow) payRow.hidden = empty;
    var scrollEl = qs('.nucery-cart-drawer__scroll');
    if (scrollEl) scrollEl.classList.toggle('nucery-cart-drawer__scroll--empty', empty);
  }

  function applyCart(cart, options) {
    if (!ensureRoot()) return cart;
    options = options || {};
    if (cart.currency) config.currency = cart.currency;
    applyThresholdsFromConfig();
    toggleEmpty(cart);
    renderItems(cart, options);
    renderProgress(cart);
    renderTotals(cart);
    return cart;
  }

  function refresh(options) {
    if (!ensureRoot()) return Promise.resolve();
    readConfig();
    return fetchCart().then(function (cart) {
      return applyCart(cart, options);
    });
  }

  function openDrawer() {
    if (!ensureRoot()) return Promise.resolve();
    readConfig();
    suppressLegacyCartUi();
    var wasOpen = open;
    if (!open) {
      open = true;
      root.classList.remove('nucery-cart-drawer--is-closing');
      root.classList.add('nucery-cart-drawer--is-open');
      root.setAttribute('aria-hidden', 'false');
      setBodyScroll(true);
    }
    return refresh({ animate: !wasOpen }).then(function (cart) {
      if (!wasOpen) {
        var closeBtn = qs('[data-nucery-cart-close]');
        if (closeBtn) closeBtn.focus();
      }
      return cart;
    });
  }

  /** After add-to-cart: load /cart.js first, then reveal drawer with the new line item. */
  function openDrawerWithFreshCart() {
    if (!ensureRoot()) return Promise.resolve();
    readConfig();
    suppressLegacyCartUi();
    if (open) {
      return refresh({ animate: true });
    }
    return fetchCart().then(function (cart) {
      applyCart(cart, { animate: true });
      open = true;
      root.classList.remove('nucery-cart-drawer--is-closing');
      root.classList.add('nucery-cart-drawer--is-open');
      root.setAttribute('aria-hidden', 'false');
      setBodyScroll(true);
      var closeBtn = qs('[data-nucery-cart-close]');
      if (closeBtn) closeBtn.focus();
      return cart;
    });
  }

  var CART_CLOSE_MS = 420;

  function finishCartClose() {
    if (!root) return;
    root.classList.remove('nucery-cart-drawer--is-closing');
  }

  function closeDrawer() {
    if (!open) return;
    open = false;
    ensureRoot();
    if (!root) return;
    root.classList.add('nucery-cart-drawer--is-closing');
    root.classList.remove('nucery-cart-drawer--is-open');
    root.setAttribute('aria-hidden', 'true');
    setBodyScroll(false);

    var panel = qs('.nucery-cart-drawer__panel');
    var done = false;
    function end() {
      if (done) return;
      done = true;
      if (panel) panel.removeEventListener('transitionend', onEnd);
      finishCartClose();
    }
    function onEnd(e) {
      if (!panel || e.target !== panel || e.propertyName !== 'transform') return;
      end();
    }
    if (panel) panel.addEventListener('transitionend', onEnd);
    window.setTimeout(end, CART_CLOSE_MS + 60);
  }

  function bindOpens() {
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target.closest('[data-nucery-cart-open]');
        if (!t) return;
        e.preventDefault();
        e.stopPropagation();
        suppressLegacyCartUi();
        openDrawer();
      },
      true
    );
  }

  var drawerDocListenersBound = false;

  function bindRoot() {
    if (drawerDocListenersBound) return;
    drawerDocListenersBound = true;

    document.addEventListener(
      'click',
      function (e) {
        if (!e.target.closest('#NuceryCartDrawer')) return;
        if (e.target.closest('[data-nucery-cart-close]') || e.target.closest('[data-nucery-cart-backdrop]')) {
          closeDrawer();
          return;
        }
        var rm = e.target.closest('[data-remove-line]');
        if (rm) {
          e.preventDefault();
          changeLine(rm.getAttribute('data-remove-line'), 0);
          return;
        }
        var deltaBtn = e.target.closest('[data-qty-delta]');
        if (deltaBtn) {
          e.preventDefault();
          var row = deltaBtn.closest('.nucery-cart-drawer__item');
          if (!row) return;
          var key = row.getAttribute('data-line-key');
          var delta = parseInt(deltaBtn.getAttribute('data-qty-delta'), 10);
          var valEl = row.querySelector('.nucery-cart-drawer__qty-val');
          var cur = parseInt(valEl && valEl.textContent, 10) || 1;
          var next = Math.max(0, cur + delta);
          if (valEl) valEl.textContent = String(next);
          changeLine(key, next).catch(function () {
            if (valEl) valEl.textContent = String(cur);
          });
        }
      },
      false
    );

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) closeDrawer();
    });
  }

  /** Route all theme / Alpine cart entry points to this drawer. */
  function installCartTakeover() {
    function ncdOpen() {
      if (window.NuceryCartDrawer) window.NuceryCartDrawer.open();
    }
    function ncdClose() {
      if (window.NuceryCartDrawer) window.NuceryCartDrawer.close();
    }
    function ncdUpdate(shouldOpen) {
      if (shouldOpen) ncdOpen();
      var p = shouldOpen
        ? Promise.resolve()
        : window.NuceryCartDrawer
          ? window.NuceryCartDrawer.refresh()
          : Promise.resolve();
      return p.then(function () {
        suppressLegacyCartUi();
      });
    }

    window.openCart = ncdOpen;
    window.closeCart = ncdClose;
    window.updateCart = ncdUpdate;
    window.__ncdCartTakeover = { open: ncdOpen, close: ncdClose, update: ncdUpdate };

    patchImpulseProductFormSuccess();
    neutralizeImpulseCartDrawer();
    suppressLegacyCartUi();
  }

  /** Prevent Impulse `cartType: page` redirect when Nucery drawer is active. */
  function patchImpulseProductFormSuccess() {
    if (!window.theme || !window.theme.AjaxProduct) return;
    var proto = window.theme.AjaxProduct.prototype;
    if (!proto || proto.__ncdSuccessPatched) return;
    var originalSuccess = proto.success;
    proto.success = function (product) {
      var settings = window.theme && window.theme.settings;
      var prevCartType = settings && settings.cartType;
      if (prevCartType === 'page' && window.NuceryCartDrawer && settings) {
        settings.cartType = 'drawer';
      }
      try {
        originalSuccess.call(this, product);
      } finally {
        if (settings && prevCartType === 'page' && window.NuceryCartDrawer) {
          settings.cartType = prevCartType;
        }
      }
    };
    proto.__ncdSuccessPatched = true;
  }

  function neutralizeImpulseCartDrawer() {
    if (!window.theme || !window.theme.CartDrawer) return;
    var proto = window.theme.CartDrawer.prototype;
    if (proto && !proto.__ncdPatched) {
      proto.open = function () {
        if (window.NuceryCartDrawer) window.NuceryCartDrawer.open();
      };
      proto.close = function () {
        if (window.NuceryCartDrawer) window.NuceryCartDrawer.close();
      };
      proto.__ncdPatched = true;
    }
  }

  /** Hide upsell slide-out + mini alert cart (theme__cart in overlay-group). */
  function suppressLegacyCartUi() {
    document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--cart', 'js-drawer-closing');

    var impulseDrawer = document.getElementById('CartDrawer');
    if (impulseDrawer) {
      impulseDrawer.setAttribute('aria-hidden', 'true');
      impulseDrawer.classList.remove('drawer--is-open');
    }

    var legacySections = document.querySelectorAll(
      '.shopify-section[id*="theme__cart"], .shopify-section[id*="theme_cart"], [data-ncd-legacy-cart]'
    );
    legacySections.forEach(function (el) {
      el.setAttribute('data-ncd-legacy-cart', '');
      el.setAttribute('aria-hidden', 'true');
    });

    try {
      var body = document.body;
      if (body && body._x_dataStack && body._x_dataStack.length) {
        body._x_dataStack.forEach(function (data) {
          if (data && Object.prototype.hasOwnProperty.call(data, 'cart_alert')) {
            data.cart_alert = false;
          }
        });
      }
    } catch (err) {
      /* Alpine optional */
    }
  }

  function dispatchAjaxProductAdded(data, triggerEl) {
    if (data && data.status === 422) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      return;
    }
    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: { product: data, addToCartBtn: triggerEl || null },
      })
    );
  }

  function ajaxAddVariant(variantId, quantity, triggerEl) {
    var qty = quantity || 1;
    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(qty));
    var addUrl = '/cart/add.js';
    if (window.theme && window.theme.routes && window.theme.routes.cartAdd) {
      addUrl = window.theme.routes.cartAdd;
    }
    if (triggerEl && triggerEl.setAttribute) {
      triggerEl.setAttribute('aria-busy', 'true');
    }
    return fetch(addUrl, {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        dispatchAjaxProductAdded(data, triggerEl);
        return data;
      })
      .finally(function () {
        if (triggerEl && triggerEl.removeAttribute) {
          triggerEl.removeAttribute('aria-busy');
        }
      });
  }

  function isInterceptedCartAddForm(form) {
    if (!form || !form.matches) return false;
    if (form.matches('form.bestsellers-card__quick')) return true;
    if (form.querySelector('[data-cfs-add]')) return true;
    return false;
  }

  /**
   * Sections that POST to /cart/add (bestsellers cards, custom follow look items, etc.)
   * are converted to AJAX add + Nucery drawer open.
   */
  function bindInterceptedCartAddForms() {
    if (bindInterceptedCartAddForms._bound) return;
    bindInterceptedCartAddForms._bound = true;

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!isInterceptedCartAddForm(form)) return;
        e.preventDefault();
        e.stopPropagation();
        var idInput = form.querySelector('input[name="id"]');
        var qtyInput = form.querySelector('input[name="quantity"]');
        var variantId = idInput ? parseInt(idInput.value, 10) : 0;
        if (!variantId) return;
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        var btn = form.querySelector('[data-bst-quick], [data-cfs-add]');
        ajaxAddVariant(variantId, qty, btn);
      },
      true
    );
  }

  function onCartOpenRequest(e) {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
    if (e && typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    suppressLegacyCartUi();
    if (!window.NuceryCartDrawer) return;
    if (e && e.type === 'ajaxProduct:added') {
      var added = e.detail && e.detail.product;
      if (added && added.status === 422) return;
      openDrawerWithFreshCart();
      return;
    }
    if (open) window.NuceryCartDrawer.refresh();
    else window.NuceryCartDrawer.open();
  }

  function bindCartTakeoverEvents() {
    if (bindCartTakeoverEvents._bound) return;
    bindCartTakeoverEvents._bound = true;

    document.addEventListener('ajaxProduct:added', onCartOpenRequest, true);
    document.addEventListener('cart:open', onCartOpenRequest, true);

    document.addEventListener(
      'cart:updated',
      function () {
        suppressLegacyCartUi();
      },
      false
    );
  }

  function onSectionLoad(e) {
    var sec = e && e.target;
    if (!sec || typeof sec.querySelector !== 'function') return;
    if (!sec.querySelector('#NuceryCartDrawer')) return;
    prevTierState = null;
    if (open) {
      open = false;
      setBodyScroll(false);
    }
    ensureRoot();
    readConfig();
    refresh();
  }

  function init() {
    bindInterceptedCartAddForms();
    if (!ensureRoot()) return;
    readConfig();

    installCartTakeover();
    bindCartTakeoverEvents();
    bindOpens();
    bindRoot();

    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:select', onSectionLoad);

    document.addEventListener('cart:updated', function () {
      refresh();
    });

    refresh();

    window.addEventListener('load', function () {
      installCartTakeover();
      patchImpulseProductFormSuccess();
      neutralizeImpulseCartDrawer();
      suppressLegacyCartUi();
    });

    var takeoverAttempts = 0;
    var takeoverTimer = setInterval(function () {
      installCartTakeover();
      patchImpulseProductFormSuccess();
      neutralizeImpulseCartDrawer();
      if (++takeoverAttempts >= 20) clearInterval(takeoverTimer);
    }, 250);
  }

  window.NuceryCartDrawer = {
    open: openDrawer,
    openAfterAdd: openDrawerWithFreshCart,
    close: closeDrawer,
    refresh: refresh,
    isOpen: function () {
      return open;
    },
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
